/**
 * Core System Constants - Centralized to avoid circular dependencies.
 */

// F&B OS Default Application Identifier
export const POS_CONFIG_APP_ID = import.meta.env.VITE_POS_APP_ID || 'fnb-os';

// System Identification Prefix for Auditability
export const SYSTEM_ID_PREFIX = 'ID-OPT-';
